import React, { useContext } from 'react';
import { UiContext } from 'States/ui/uiState';
import Text from 'Components/shared/Text';
import DefaultCardButtonGroup from 'Components/shared/cards/DefaultCardButtonGroup';

const CustomCard = ({
  name = '',
  subtitle = 'test subtitle',
  description = '',
  iconUrl = '',
  buttons = [],
  svg,
  dataQa,
  buttonGroup = DefaultCardButtonGroup,
}) => {
  const {
    breakpoints: { md, xxl },
  } = useContext(UiContext);

  const iconSize = xxl ? '163px' : md ? '163px' : '226px';

  return (
    <div
      data-qa={dataQa}
      className="grid w-full"
      style={{
        // md
        //   ? {
            width: '100%',
            maxWidth: '340px',
            gridTemplate: `"icon" "description"
                             "buttons"`,
            gridTemplateRows: `max(35%, ${iconSize}) minmax(0, 1fr) auto`,
            borderRadius: '20px',
            paddingBottom: '30px',
            backgroundColor: '#f3f5f8'
          // }
          // : {
          //   gridTemplate: `"icon description"
          //     "buttons buttons"`,
          //   gridTemplateColumns: '90px minmax(0, 1fr)',
          // }
      }}
    >
      {iconUrl && (
        <img
          alt={`${name}`}
          src={`${iconUrl}`}
          style={{
            height: "100%",
            width: "100%",
            objectFit: 'fill',
            gridArea: 'icon',
            borderRadius: '20px 20px 0 0',
            aspectRatio: '3/2'
          }}
        />
      )}
      {svg ? (
        <div
          data-qa={`${dataQa}-imageWrapper`}
          className="bg-lightGrey flex justify-center items-center rounded md:rounded-none md:rounded-t"
          style={{
            height: iconSize,
            minWidth: iconSize,
            gridArea: 'icon'
          }}
        >
          {svg}
        </div>
      ) : null}
      <div
        className="flex flex-col px-16 mt-10"
        style={{ gridArea: 'description' }}
      >
        {!!subtitle && (
          <Text
            color="text-black"
            textStyle="text-small"
            style={{
              fontFamily: "Cuprum, sans-serif"
            }}
            data-qa={`${dataQa}-subtitle`}
          >
            {subtitle}
          </Text>
        )}
        <div
          data-qa={`${dataQa}-title`}
          className='text-black font-bold mt-10'
          style={{
            fontFamily: "Cuprum, sans-serif",
            fontSize: "26px",
            lineHeight: "28px"
          }}
        >
          {name}
        </div>
        <div
          className='bg-black mb-10'
          style={{
            width: "55px",
            height: "1px",
            marginTop: "15px",
          }}
        ></div>
        <Text
          color='text-black'
          dataQa={`${dataQa}-description`}
          style={{
            fontFamily: "DM Sans, sans-serif",
            marginBottom: "18px",
            color: "#001f3e"
          }}
          className="break-words"
        >
          {description}
        </Text>
      </div>
      {buttons && buttonGroup({ buttons, dataQa })}
    </div>
  );
};

export default CustomCard;
